// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vue3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vue3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.process_name_indicator[data-v-21681d75] {
  position: absolute;
  top: 1.5%;
  z-index: 99;
  color: #fff;
  border-radius: 20px;
  padding: 6px 20px;
  font-size: 12px;
  display: none;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  left: 0;
  right: 0;
  max-width: max-content;
  margin: 0 auto;
}
.process_name_indicator.animated_bottom[data-v-21681d75] {
  display: block;
  animation: animated_bottom-21681d75 1s;
  transition: 0.5s;
}
@keyframes animated_bottom-21681d75 {
0% {
    transform: translateY(30px);
}
100% {
    transform: translateY(0px);
}
}
.border-full[data-v-21681d75] {
  position: absolute;
  height: 1px;
  top: 3vh;
  left: 0;
  display: none;
  transition: width 0.6s linear;
  right: 0;
  margin: 0 auto;
  z-index: 9;
  opacity: 0.5;
}
.border-full.animated_border[data-v-21681d75] {
  animation: animated_border-21681d75 5s;
  transition: 0.5s;
  display: block;
}
@keyframes animated_border-21681d75 {
0% {
    width: 0%;
}
100% {
    width: 100%;
    display: block;
}
}
@media (min-width: 1900px) {
.border-full[data-v-21681d75] {
    top: 2.8vh;
}
}
`, "",{"version":3,"sources":["webpack://./../js/components/shared/ChatWidget/TvmFlowNameIndicator/TvmFlowNameIndicator.vue","webpack://./TvmFlowNameIndicator.vue"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,+CAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,cAAA;ACAF;ADGA;EACE,cAAA;EACA,sCAAA;EACA,gBAAA;ACDF;ADIA;AACE;IACE,2BAAA;ACFF;ADKA;IACE,0BAAA;ACHF;AACF;ADMA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,6BAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;ACJF;ADME;EACE,sCAAA;EACA,gBAAA;EACA,cAAA;ACJJ;ADQA;AACE;IACE,SAAA;ACNF;ADSA;IACE,WAAA;IACA,cAAA;ACPF;AACF;ADUA;AACE;IACE,UAAA;ACRF;AACF","sourcesContent":["\n.process_name_indicator {\n  position: absolute;\n  top: 1.5%;\n  z-index: 99;\n  color: #fff;\n  border-radius: 20px;\n  padding: 6px 20px;\n  font-size: 12px;\n  display: none;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n  left: 0;\n  right: 0;\n  max-width: max-content;\n  margin: 0 auto;\n}\n\n.process_name_indicator.animated_bottom {\n  display: block;\n  animation: animated_bottom 1s;\n  transition: 0.5s;\n}\n\n@keyframes animated_bottom {\n  0% {\n    transform: translateY(30px);\n  }\n\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n.border-full {\n  position: absolute;\n  height: 1px;\n  top: 3vh;\n  left: 0;\n  display: none;\n  transition: width 0.6s linear;\n  right: 0;\n  margin: 0 auto;\n  z-index: 9;\n  opacity: 0.5;\n\n  &.animated_border {\n    animation: animated_border 5s;\n    transition: 0.5s;\n    display: block;\n  }\n}\n\n@keyframes animated_border {\n  0% {\n    width: 0%;\n  }\n\n  100% {\n    width: 100%;\n    display: block;\n  }\n}\n\n@media (min-width: 1900px) {\n  .border-full {\n    top: 2.8vh;\n  }\n}\n",".process_name_indicator {\n  position: absolute;\n  top: 1.5%;\n  z-index: 99;\n  color: #fff;\n  border-radius: 20px;\n  padding: 6px 20px;\n  font-size: 12px;\n  display: none;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n  left: 0;\n  right: 0;\n  max-width: max-content;\n  margin: 0 auto;\n}\n.process_name_indicator.animated_bottom {\n  display: block;\n  animation: animated_bottom 1s;\n  transition: 0.5s;\n}\n@keyframes animated_bottom {\n  0% {\n    transform: translateY(30px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n.border-full {\n  position: absolute;\n  height: 1px;\n  top: 3vh;\n  left: 0;\n  display: none;\n  transition: width 0.6s linear;\n  right: 0;\n  margin: 0 auto;\n  z-index: 9;\n  opacity: 0.5;\n}\n.border-full.animated_border {\n  animation: animated_border 5s;\n  transition: 0.5s;\n  display: block;\n}\n@keyframes animated_border {\n  0% {\n    width: 0%;\n  }\n  100% {\n    width: 100%;\n    display: block;\n  }\n}\n@media (min-width: 1900px) {\n  .border-full {\n    top: 2.8vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
